export default __webpack_public_path__ + "static/media/fl2.446221bf.png";